function isByteArray(value) {
    return value instanceof Uint8Array || value instanceof Uint8ClampedArray;
}
export function validatePixelImage(image) {
    if (!image || typeof image !== 'object')
        return { error: 'Image must be an object.' };
    if (!Number.isInteger(image.width) || image.width < 1)
        return { error: 'Image width must be a positive integer.' };
    if (!Number.isInteger(image.height) || image.height < 1)
        return { error: 'Image height must be a positive integer.' };
    if (!isByteArray(image.data))
        return { error: 'Image data must be a Uint8Array or Uint8ClampedArray.' };
    if (image.format !== 'rgb8' && image.format !== 'rgba8')
        return { error: 'Image format must be rgb8 or rgba8.' };
    const channels = image.format === 'rgb8' ? 3 : 4;
    const stride = image.strideBytes ?? image.width * channels;
    if (!Number.isInteger(stride) || stride < image.width * channels) {
        return { error: 'Image strideBytes must be an integer large enough for one row.' };
    }
    const requiredBytes = stride * (image.height - 1) + image.width * channels;
    if (image.data.length < requiredBytes) {
        return { error: `Image data is too small: got ${image.data.length} bytes, need ${requiredBytes}.` };
    }
    if (channels === 4) {
        for (let y = 0; y < image.height; y++) {
            const row = y * stride;
            for (let x = 0; x < image.width; x++) {
                if (image.data[row + x * 4 + 3] !== 255)
                    return { error: 'rgba8 input must be fully opaque.' };
            }
        }
    }
    return {
        image: {
            width: image.width,
            height: image.height,
            data: image.data,
            channels,
            stride,
        },
    };
}
export function validRectShape(value) {
    if (!value || typeof value !== 'object')
        return false;
    const rect = value;
    return Number.isInteger(rect.x)
        && Number.isInteger(rect.y)
        && Number.isInteger(rect.width)
        && Number.isInteger(rect.height)
        && rect.x >= 0
        && rect.y >= 0
        && rect.width > 0
        && rect.height > 0;
}
export function rectInside(image, rect) {
    return rect.x >= 0
        && rect.y >= 0
        && rect.x + rect.width <= image.width
        && rect.y + rect.height <= image.height;
}
//# sourceMappingURL=input.js.map